import styled from "styled-components";
import { MediaStyle, basic } from "../../../utils/style-utils";

export const NavToggleStyle = styled.a`
  text-decoration: none;
  color: ${basic.secondary};
  font-size: 1.5rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  span {
    display: none;
  }
  ${MediaStyle.md`
      display: none;
  `}
`;

export const ButtonWrapperStyle = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1rem;

  & > div {
    margin-left: 0.5rem;
  }

  button {
    margin: 10px 5px;
    ${MediaStyle.smOnly`
      div {
        font-size: 1.5rem;
      }
  `}
  }
`;

export const LogoStyle = styled.div`
  width: 130px;
  height: 40px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  ${MediaStyle.md`
    width: 163px;
    height: 51px;
  `}
`;

export const LanguageSelectorStyled = styled.div`
  height: 46px;
  width: 46px;
  border: 2px solid #004615;
  a {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 20px;
    color: #004615;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/primNav/style.js